import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VToolbar,{attrs:{"flat":""}},[_c(VToolbarTitle,[_vm._v("My Profile")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }